export default () => ({
  sortableIdentificationIsActive: false,
  sideBySideIdentification: true,
  summaries: [],
  summary: '',

  entities: 'summaries'
})



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/identification/resources/data.js